<template>
  <div class="image-crop-wrapper">
    <div class="cropper-title-bar">
      <div class="title-btn-container">
        <label class="select-image" for="uploads">选择图片</label>
        <input
          type="file"
          id="uploads"
          :disabled="cutDone"
          class="image-input"
          :value="imgFile"
          :accept="accept"
          @change="uploadImg($event, 1)"
        />
        <el-button class="cropper-btn" title="放大" @click="changeScale(1)">
          <i class="el-icon-plus"></i>
        </el-button>
        <el-button class="cropper-btn" title="缩小" @click="changeScale(-1)">
          <i class="el-icon-minus"></i>
        </el-button>
      </div>
    </div>
    <div class="cropper-edit-area flex">
      <div class="cropper-container">
        <VueCropper
          ref="cropper"
          :img="option.img"
          :outputSize="option.size"
          :outputType="option.outputType"
          :info="true"
          :full="option.full"
          :canMove="option.canMove"
          :canMoveBox="option.canMoveBox"
          :original="option.original"
          :autoCrop="option.autoCrop"
          :autoCropWidth="option.autoCropWidth"
          :autoCropHeight="option.autoCropHeight"
          :fixedBox="option.fixedBox"
          @realTime="realTime"
          @imgLoad="imgLoad"
        ></VueCropper>
      </div>
      <div class="preview-container">
        <div :style="previews.div" class="preview">
          <img :src="previews.url" :style="previews.img" />
        </div>
      </div>
    </div>
    <div class="cropper-foot-bar">
      <div class="foot-btn-container">
        <el-button
          type="primary"
          :disabled="cutDone"
          class="cropper-btn"
          @click="finish('blob')"
          >完成</el-button
        >
        <span class="uploaded-tip">提示：头像上传成功后，请点击保存</span>
      </div>
    </div>
  </div>
</template>
<script>
import { VueCropper } from "vue-cropper";
import { apiMap } from "../../utils/apiMap";
import { newFileName } from "../../utils/feed";
export default {
  name: "image-cropper",
  data() {
    return {
      cutDone: false,
      crap: false, //剪切图片上传
      previews: {},
      option: {
        img: "",
        outputSize: 1, //剪切后的图片质量（0.1-1）
        full: false, //输出原图比例截图 props名full
        outputType: "png",
        canMove: true,
        original: false,
        canMoveBox: true,
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true,
      },
      fileName: "", //本机文件地址
      downImg: "#",
      imgFile: "",
      uploadImgRelaPath: "", //上传后的图片的地址（不带服务器域名）
      accept: "image/png, image/jpeg, image/gif, image/jpg",
    };
  },
  components: {
    VueCropper,
  },
  methods: {
    resetCropper() {
      (this.option.img = ""), this.$refs.cropper.clearCrop();
      this.cutDone = false;
    },
    changeScale(num) {
      num = num || 1;
      this.$refs.cropper.changeScale(num);
    },
    realTime(data) {
      this.previews = data;
    },
    imgLoad(msg) {},
    finish(type) {
      let _this = this;
      let formData = new FormData();
      // 输出
      if (type === "blob") {
        _this.$refs.cropper.getCropBlob((data) => {
          let img = window.URL.createObjectURL(data);
          _this.model = true;
          _this.modelSrc = img;
          var alias = newFileName(_this.fileName);
          var fileA = new File([data], alias, {
            type: "image/png",
            lastModified: new Date(),
          });
          formData.append("file", fileA, alias);
          _this
            .$axios({
              baseURL: apiMap["uploadUrl"],
              method: apiMap["uploadFile"]["method"],
              url: apiMap["uploadFile"]["url"],
              data: formData,
              timeout: 4000,
            })
            .then(function (response) {
              if (response.data.code == 200) {
                _this.$emit("cropDone", 1, response.data.file);
                _this.resetCropper();
              } else {
                _this.$message({
                  message: "图片上传失败，稍后再试",
                  type: "warning",
                  duration: 1500,
                  offset: 230,
                });
                _this.$emit("cropDone", 2);
                _this.resetCropper();
              }
            })
            .catch(function (error) {
              console.log(error);
              if (error.message.includes("timeout")) {
                $this.$alert("文件上传超时", {
                  confirmButtonText: "确定",
                  showClose: false,
                });
              } else {
                $this.$message({
                  message: "文件上传出错",
                  type: "warning",
                  duration: 1500,
                  offset: 230,
                });
              }
            });
        });
      } else {
        this.$refs.cropper.getCropData((data) => {
          this.model = true;
          this.modelSrc = data;
        });
      }
    },
    uploadImg(e, num) {
      var _this = this;
      //上传图片
      var file = e.target.files[0];
      _this.fileName = file.name;
      if (!/\.(gif|jpg|jpeg|png|bmp|GIF|JPG|PNG)$/.test(e.target.value)) {
        alert("图片类型必须是.gif,jpeg,jpg,png,bmp中的一种");
        return false;
      }
      var reader = new FileReader();
      reader.onload = (e) => {
        let data;
        if (typeof e.target.result === "object") {
          // 把Array Buffer转化为blob 如果是base64不需要
          data = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          data = e.target.result;
        }
        if (num === 1) {
          _this.option.img = data;
        } else if (num === 2) {
          _this.example2.img = data;
        }
      };
      // 转化为base64
      // reader.readAsDataURL(file)
      // 转化为blob
      reader.readAsArrayBuffer(file);
    },
  },
};
</script>
<style scoped>
.title-btn-container {
  position: relative;
  width: 600px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
}

.cropper-btn {
  padding: 6px 10px;
}

.select-image {
  display: inline-block;
  width: 70px;
  height: 26px;
  margin-right: 10px;
  cursor: pointer;
  color: #606266;
  line-height: 26px;
  text-align: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
}

.select-image:focus,
.select-image:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background-color: #ecf5ff;
}

.image-input {
  position: absolute;
  clip: rect(0 0 0 0);
}

.cropper-edit-area {
  width: 600px;
  height: 300px;
  margin: 0 auto;
  justify-content: space-between;
  border: 1px solid #ccc;
}

.cropper-container {
  width: 60%;
}

.preview-container {
  display: flex;
  width: 240px;
  height: 100%;
  overflow: hidden;
  justify-content: center;
  align-items: center;
  border-left: 1px solid #ccc;
}

.preview-container .preview {
  overflow: hidden;
  border-radius: 50%;
  border: 1px solid #cccccc;
  background: #cccccc;
}

.foot-btn-container {
  width: 600px;
  height: 40px;
  line-height: 40px;
  margin: 0 auto;
}

.uploaded-tip {
  margin-left: 10px;
  color: #2ca92e;
}
</style>